import { useEffect } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Header from "../../views/layout/Header";
import Sidebar from "../../views/layout/Sidebar";

import JobRoutes from "../../views/pages/Administration/Jobs/routes";
import RolesPermissions from "../../views/pages/Administration/Settings/RolesPermissions";
import CompanyDirectoryRoutes from "../../views/pages/CompanyDirectory/routes";
import DiscountPage from "../../views/pages/Discount";
import EmployeeRoutes from "../../views/pages/Employees/routes";
import EmployeeDashboard from "../../views/pages/MainPages/Dashboard/EmployeeDashboard";
import MenuPage from "../../views/pages/Menu";
import OrgChartPage from "../../views/pages/OrgChart";

import Holidays from "../../views/pages/Employees/Holidays";
import LeaveCalandar from "../../views/pages/Employees/leaves/calendar";
import EmployeeLeave from "../../views/pages/Employees/leaves/EmployeeLeave";
import LeavePlanner from "../../views/pages/Employees/leaves/leavePlanner";

import Department from "../../views/pages/Others/Department";
import Designation from "../../views/pages/Others/Designation";
import Expenses from "../../views/pages/Expenses";

import BottomNav from "views/layout/bottomNav";
import JobDriveDashboard from "../../views/pages/Administration/Jobs/JobDrive";
import JobDriveAttendance from "../../views/pages/Administration/Jobs/JobDrive/JobDriveAttendance";
import JobDriveInvitations from "../../views/pages/Administration/Jobs/JobDrive/JobDriveDashboardList";
import JobDriveScan from "../../views/pages/Administration/Jobs/JobDrive/JobDriveScan";
import JobDriveSlots from "../../views/pages/Administration/Jobs/JobDrive/JobDriveSlots";
import RequestApprover from "../../views/pages/Administration/Settings/RequestApprover";
import AssetRoutes from "../../views/pages/Assets/routes";
import DocumentRoutes from "../../views/pages/Documents/routes";
import EmployeeReferrals from "../../views/pages/EmployeeReferral/routes";
import EmployeeStats from "../../views/pages/MainPages/Dashboard/EmployeeStats";
import DataSync from "../../views/pages/Others/dataSync";
import GradesRoutes from "../../views/pages/Others/Grades/routes";
import ResignationRoutes from "../../views/pages/Resignation/routes";
import ResumeRoutes from "../../views/pages/Resumes/routes";
import SalaryRoutes from "../../views/pages/Salary/routes";
import UniformManagement from "../../views/pages/UniformManagement";
import SizeSelectionModal from "../../views/pages/UniformManagement/employee/sizeSelection/SizeSelectionModal";
import PendingAcceptanceModal from "../../views/pages/UniformManagement/employee/pendingAcceptance/PendingAcceptanceModal";

import { useDispatch } from "react-redux";
import { fetchUser } from "store/slice/user";

const AppContainer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUser());
  }, [dispatch]);

  const routingObjects = [
    {
      id: 17,
      path: "employee-dashboard",
      element: <EmployeeDashboard />,
    },
    {
      id: 200,
      path: "menu",
      element: <MenuPage />,
    },
    {
      id: 201,
      path: "discount",
      element: <DiscountPage />,
    },
    {
      id: 34,
      path: "employees",
      element: <EmployeeRoutes />,
    },
    {
      id: 34,
      path: "company-directory",
      element: <CompanyDirectoryRoutes />,
    },
    {
      id: 34,
      path: "org-chart",
      element: <OrgChartPage />,
    },
    {
      id: 35,
      path: "holidays",
      element: <Holidays />,
    },
    {
      id: 37,
      path: "leaves-employee",
      element: <EmployeeLeave />,
    },
    {
      id: 37,
      path: "leave-calendar",
      element: <LeaveCalandar />,
    },
    {
      id: 37,
      path: "leave-planner",
      element: <LeavePlanner />,
    },
    {
      id: 41,
      path: "departments",
      element: <Department />,
    },
    {
      id: 42,
      path: "designations",
      element: <Designation />,
    },
    {
      id: 65,
      path: "expenses",
      element: <Expenses />,
    },
    {
      id: 76,
      path: "salary",
      element: <SalaryRoutes />,
    },
    {
      id: 132,
      path: "documents",
      element: <DocumentRoutes />,
    },
    {
      id: 134,
      path: "assets",
      element: <AssetRoutes />,
    },
    {
      id: 250,
      path: "uniform-management",
      element: <UniformManagement />,
    },
    {
      id: 135,
      path: "employee-statistics",
      element: <EmployeeStats />,
    },
    {
      id: 136,
      path: "grades",
      element: <GradesRoutes />,
    },
    {
      id: 4,
      path: "roles-permissions",
      element: <RolesPermissions />,
    },
    {
      id: 137,
      path: "request-approver",
      element: <RequestApprover />,
    },
    {
      id: 138,
      path: "resignations",
      element: <ResignationRoutes />,
    },
    {
      id: 139,
      path: "sync-data",
      element: <DataSync />,
    },
  ];

  const AdministrationRoutingeObjects = [
    {
      id: 13,
      path: "manage-jobs",
      element: <JobRoutes />,
    },
    {
      id: 27,
      path: "job-drive-slots",
      element: <JobDriveSlots />,
    },
    {
      id: 28,
      path: "job-drive-dashboard",
      element: <JobDriveInvitations />,
    },
    {
      id: 31,
      path: "job-drive-scan",
      element: <JobDriveScan />,
    },
    {
      id: 29,
      path: "job-drive/:id",
      element: <JobDriveDashboard />,
    },
    {
      id: 30,
      path: "job-drive-attendance",
      element: <JobDriveAttendance />,
    },
    {
      id: 14,
      path: "manage-resumes",
      element: <ResumeRoutes />,
    },
    {
      id: 26,
      path: "employee-referrals",
      element: <EmployeeReferrals />,
    },
  ];

  const SidebarLayout = () => (
    <>
      <Header />
      <Sidebar />
      <BottomNav />

      <SizeSelectionModal />
      <PendingAcceptanceModal />
      <Outlet />
    </>
  );

  const mobileResponsive = (event) => {
    const excludedHeader = document.querySelector(".header");
    const excludedSidebar = document.querySelector(".sidebar");

    if (
      !excludedHeader.contains(event.target) &&
      !excludedSidebar.contains(event.target)
    ) {
      document.body.classList.remove("slide-nav");
    }
  };

  return (
    <>
      <div className="main-wrapper" onClick={mobileResponsive}>
        <Routes>
          <Route path={"/*"} element={<SidebarLayout />}>
            {routingObjects.map((item) => (
              <Route key={item.id} path={`${item.path}/*`} element={item.element} />
            ))}
          </Route>

          <Route path={"/*"} element={<SidebarLayout />}>
            {AdministrationRoutingeObjects.map((item) => (
              <Route key={item.id} path={item.path} element={item.element} />
            ))}
          </Route>
          <Route path={"/*"} element={<SidebarLayout />}>
            <Route path="*" element={<Navigate to="/" />} />
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default AppContainer;
